var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsSmallBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#777"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "icons_small_bookmark_svg__a",
    d: "M16.723 19.824l-5.607-2.972L5.6 20l.968-6.497L2 8.984l6.204-1.043L10.9 2l2.867 5.852 6.232.848-4.434 4.66z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icons_small_bookmark_svg__a",
    transform: "translate(-2 -2)",
    fillRule: "evenodd"
  })));
}
export default SvgIconsSmallBookmark;